module.exports = __webpack_public_path__ + "static/media/bo.6b07c0bc.png";